export const Queries = Object.freeze({
  KEYWORD: 'keyword',
  FILTER: 'filter',
  LANG: 'lang',
  REL: 'rel',
  TYPE: 'type',
  ACTION: 'action',
  CATEGORY: 'category',
})
